<template>
    <div
        class="chessboard flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded border"
    >
        <img
            v-if="url"
            :src="url"
            alt=""
            class="max-h-full max-w-full object-contain"
        />
        <SmuIcon
            v-else
            :icon="task.kind === 'svg-edit' ? 'bezier-curve' : 'image'"
            type="light"
            class="text-neutral-5"
        />
    </div>
</template>

<script setup lang="ts">
import { SmuIcon } from "@smakecloud/smake-ui";
import { computed, watchEffect } from "vue";
import type { VectorizeTask } from "~/lib/api/types/vectorizeTasks";

const props = defineProps<{ task: VectorizeTask }>();

const store = useVectorizeTaskStore();

const url = computed(() => store.thumbnails.get(props.task.id));

watchEffect(() => {
    store.ensureThumbnail(props.task);
});
</script>
